import { FC, ReactElement } from 'react';
import { ResponsiveContainer } from 'recharts';
import { Props } from 'recharts/types/component/ResponsiveContainer';

interface BodyProps {
  children: ReactElement;
}

const Body: FC<BodyProps & Props> = ({ children, height }) => {
  return (
    <ResponsiveContainer height={height ?? '90%'}>
      {children}
    </ResponsiveContainer>
  );
};

export default Body;
